import { INSIGHTS } from 'utils/reducers';

const initialState = {
    show: false,
};

const showInsightsReducer = (state = initialState, action) => {
    switch (action.type) {
        case INSIGHTS.display:
            return { ...state, show: true };
        case INSIGHTS.hide:
            return { ...state, show: false };
        default:
            return state;
    }
};

export default showInsightsReducer;
